var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-chart"},[_c('z-chart',{ref:_vm.name,attrs:{"id":_vm.id,"theme":_vm.theme,"options":_vm.options,"legend":_vm.legend},on:{"mounted":function($event){return _vm.getElementsChart(_vm.name)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }